import { questionTypes } from "./questionTypes";
import sortBy from "lodash/sortBy";

const replaceNbspWithSpace = (str) => (str || "").replace(/\u00A0/g, " ");

const getQuestionType = (question) => {
    return Object.keys(questionTypes).find((key) => questionTypes[key] === question.controlType) || question.controlType || "text";
};

export const sortAllowedValuesByDisplayOrder = (metadata) => {
    if (metadata.allowedValues && Array.isArray(metadata.allowedValues) && metadata.allowedValues[0]?.displayOrder) {
        metadata.allowedValues = sortBy(metadata.allowedValues, 'displayOrder');
    }
    return metadata;
};

export const questionsMapper = (questions, answers) => {
    const sorted = sortBy(questions, "displayOrder");
    return [...sorted].map((question) => questionMapper(question, answers));
};

export const getDefaultQuestionValue = (questionType) => {
    switch (questionType) {
        case "checkbox":
        case "sketch":
        case "file":
            return [];
        default:
            return "";
    }
};

export const questionMapper = (question, answers) => {
    const questionType = getQuestionType(question);

    const answerValue = answers && answers.hasOwnProperty(question.id) ? answers[question.id] : getDefaultQuestionValue(questionType);

    return {
        id: question.id,
        questionText: {
            en: replaceNbspWithSpace(question.name_en || question.nameEn),
            fr: replaceNbspWithSpace(question.name_fr || question.nameFr),
        },
        title: {
            en: replaceNbspWithSpace(question.name_en),
            fr: replaceNbspWithSpace(question.name_fr),
        },
        tooltip: {
            en: question.tooltip_en,
            fr: question.tooltip_fr,
        },
        questionType: questionType,
        displayOrder: question.displayOrder,
        props: question.metadata ? (() => {
            const metadata = JSON.parse(question.metadata);
            return sortAllowedValuesByDisplayOrder(metadata);
        })() : {},
        isAnswered: false,
        isDisabled: !!answers,
        mandatory: !!question.mandatory,
        value: answerValue,
    };
};
